import * as Yup from 'yup';

// Mirrors the API's z.array(z.string().email()).max(5) on createAndInvite.
export const CC_EMAILS_MAX = 5;

const emailSchema = Yup.string().email();

/** Comma-separated CC input → clean email list (empty segments dropped). */
export const parseCcEmails = (value?: string): string[] =>
    (value ?? '')
        .split(',')
        .map((e) => e.trim())
        .filter(Boolean);

/**
 * Single source of truth for CC validity: the SAME parse the service uses to
 * build the payload, so the validator can never reject input the serializer
 * would have cleaned (e.g. a trailing comma).
 */
export const ccEmailsValid = (value?: string): boolean => {
    const parsed = parseCcEmails(value);
    return parsed.length <= CC_EMAILS_MAX && parsed.every((e) => emailSchema.isValidSync(e));
};
